export const recentSearch = [
  {
    label: "Yam and Shrimps",
    type: "product",
  },
  {
    label: "Superman handyman",
    type: "service",
  },
  {
    label: "The silk road",
    type: "product",
  },
  {
    label: "South african sauce",
    type: "product",
  },
  {
    label: "Plumber",
    type: "service",
  },
  {
    label: "Carpenter",
    type: "service",
  },
  {
    label: "Iphone",
    type: "product",
  },
];